export interface TurnUsage {reports:number;inputTokens:number;outputTokens:number;cachedReadTokens:number}
const fields=['inputTokens','outputTokens','cachedReadTokens'] as const;
/** SSE usage values are cumulative for one provider request, not token deltas. */
export function createTurnUsage(initial:Partial<TurnUsage>={}) {
 const usage:TurnUsage={reports:0,inputTokens:0,outputTokens:0,cachedReadTokens:0,...initial};
 const requests=new Map<string,Partial<TurnUsage>>();
 return {usage,collect(event:{type:string;[key:string]:unknown}) {
  if(event.type!=='usage'||typeof event.clientRequestId!=='string')return;
  const previous=requests.get(event.clientRequestId);
  const next={...previous};
  let reported=false;
  for(const field of fields) {
   const value=event[field];
   if(typeof value!=='number'||!Number.isFinite(value)||value<0)continue;
   reported=true;const total=Math.max(previous?.[field]??0,value);
   usage[field]+=total-(previous?.[field]??0);next[field]=total;
  }
  if(reported){if(!previous)usage.reports++;requests.set(event.clientRequestId,next);}
 }};
}
